<template>
    <Card>
        <h6 class="text-uppercase font-size-base text-muted mt-2 border-bottom pb-4 text-center">
            {{ title }}
        </h6>
        <div class="pt-1">
            <div class="navi navi-hover navi-active navi-accent navi-link-rounded font-size-lg font-weight-bold">
                <slot/>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card},
    props: {
        title: String
    }
}
</script>
